import boot from '@/scripts/boot';
import app from './App.vue';

boot(app);